

export default () => ({
  pos: 0,

  init() {
    this.updateScroll();
  },

  updateScroll() {
    this.pos = document.documentElement.scrollTop || document.body.scrollTop
    requestAnimationFrame(() => this.updateScroll());
  }

});
